
/**
 * @param {React.Component} Component React component
 * @returns {string} component name (or default name if unrecognized)
 */
export const getDisplayName = Component => Component.displayName || Component.name || 'Component';



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-react/packages/hoc-utils/src/utils.js